import React from 'react';
import { FaEnvelope, FaEdit } from 'react-icons/fa';

export function ProxyMemberCard({ proxy, onEdit, onInvite }) {
  return (
    <div
      className="bg-purple-50 rounded-xl border border-purple-200 hover:border-purple-400 transition p-6"
      data-testid={`proxy-card-${proxy.proxy_id}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-4 flex-1 min-w-0">
          <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0">
            <span className="text-purple-600 font-bold text-xl">
              {proxy.name?.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-bold text-gray-800 truncate">{proxy.name}</h3>
            {proxy.relationship && (
              <p className="text-sm text-purple-600 capitalize">{proxy.relationship}</p>
            )}
            {proxy.email && (
              <p className="text-sm text-gray-600 truncate">{proxy.email}</p>
            )}
            <p className="text-xs text-gray-500">Added by {proxy.added_by_name}</p>
          </div>
        </div>
        {/* Edit Button */}
        <button
          onClick={() => onEdit(proxy)}
          className="flex items-center gap-1 px-2 py-1.5 sm:p-2 text-gray-400 hover:text-purple-600 hover:bg-purple-100 rounded-lg transition text-xs sm:text-sm"
          title="Edit member info"
          data-testid={`edit-proxy-${proxy.proxy_id}`}
        >
          <FaEdit />
          <span className="sm:hidden">Edit</span>
        </button>
      </div>
      
      {/* Invite Button */}
      <div className="mt-4 pt-4 border-t border-purple-200">
        {proxy.email ? (
          <button
            onClick={() => onInvite(proxy)}
            className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 font-medium text-sm"
            data-testid={`invite-proxy-${proxy.proxy_id}`}
          >
            <FaEnvelope />
            <span>Invite to Create Account</span>
          </button>
        ) : (
          <button
            onClick={() => onEdit(proxy)}
            className="w-full flex items-center justify-center space-x-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 font-medium text-sm"
          >
            <FaEdit />
            <span>Add Email to Enable Invitation</span>
          </button>
        )}
      </div>
    </div>
  );
}
